/**
 * sprints配列フィールドに対して単一選択として振る舞うユーティリティ
 * ルールがSINGLEの場合に使用
 */
import { ValueSetterParams } from 'ag-grid-community'
import { SprintDetail } from '../../../../lib/functions/sprint'
import { WbsItemTypeVO } from '../../../../domain/value-object/WbsItemTypeVO'
import { EntitySearchCellEditor } from '../../../containers/BulkSheetView/components/cellEditor'
import objects from '../../../../utils/objects'
import store from '../../../../store'
import { requireSave } from '../../../../store/requiredSaveData'

/**
 * 単一選択の値をsprints配列に変換するvalueSetter
 * commonValueSetterと同じ保存フロー（edited + requireSave）を踏襲
 */
export const sprintSingleValueSetter = (
  params: ValueSetterParams,
  field: string
): boolean => {
  // コピペ時に配列が渡される場合があるため、配列なら先頭要素を取り出す
  const rawValue = params.newValue
  const newValue: SprintDetail | undefined = Array.isArray(rawValue)
    ? rawValue[0]
    : rawValue
  const oldSprints: SprintDetail[] | undefined = objects.getValue(
    params.data,
    field
  )
  const newSprints = newValue ? [newValue] : []

  if (!params.data.editedData) {
    params.data.editedData = { [field]: oldSprints }
  } else if (!params.data.editedData.hasOwnProperty(field)) {
    params.data.editedData[field] = oldSprints
  }

  objects.setValue(params.data, field, newSprints)
  params.data.edited = true
  store.dispatch(requireSave())
  return true
}

/**
 * タスク行のスプリントを単一選択にするためのカラム定義オーバーライドを生成する
 * cellEditorSelector と valueSetter を返す
 */
export const createTaskSprintSingleColumnOverrides = <TRow>({
  getWbsItemType,
  getSprints,
  getWbsItemProjectUuid,
  getTeamUuid,
  sprintsField,
  baseValueSetter,
}: {
  getWbsItemType: (row: TRow | undefined) => WbsItemTypeVO | undefined
  getSprints: (row: TRow | undefined) => SprintDetail[] | undefined
  getWbsItemProjectUuid: (row: TRow | undefined) => string | undefined
  getTeamUuid: (row: TRow | undefined) => string | undefined
  sprintsField: string
  baseValueSetter: ((params: ValueSetterParams) => boolean) | undefined
}) => ({
  cellEditorSelector: (params: {
    data: TRow
    colDef: { cellEditor?: any; cellEditorParams?: any }
  }) => {
    const wbsItemType = getWbsItemType(params.data)
    if (wbsItemType?.isTask()) {
      const sprints = getSprints(params.data)
      return {
        component: EntitySearchCellEditor,
        params: {
          entity: 'sprint',
          search: undefined,
          fetch: undefined,
          value: sprints?.[0],
          optionsFilter: (option: SprintDetail, data: TRow): boolean => {
            return (
              option.projectUuid === getWbsItemProjectUuid(data) &&
              option.teamUuid === getTeamUuid(data)
            )
          },
        },
      }
    }
    return {
      component: params.colDef.cellEditor,
      params: params.colDef.cellEditorParams,
    }
  },
  valueSetter: (params: ValueSetterParams<TRow>) => {
    const wbsItemType = getWbsItemType(params.data)
    if (wbsItemType?.isTask()) {
      return sprintSingleValueSetter(params, sprintsField)
    }
    return typeof baseValueSetter === 'function'
      ? baseValueSetter(params)
      : true
  },
})
